import React, { useContext, useEffect, useState } from "react";
import useCeo from "../../hooks/useCEO";
import check from "../../assets/img/check.png";
import ruta from "../../assets/img/viaje_creado2.png";
import { useUnidades } from "../../hooks/test/useUnidades";
import { AuthContext } from "../../context/authContext/authContext";
import { SocketContext } from "../../context/SocketContext";
import Swal from "sweetalert2";
import { verifyJWT2 } from "../../helpers/JWT";
import { Loader } from "../Loader";

export const ViajesEnRuta = () => {
  useEffect(() => {
    UnidadesEnRuta();
  }, []);

  useCeo({ title: "Unidades en ruta", description: "Página de rutas" });
  const { socket } = useContext(SocketContext);
  const { postBitacora, putViajeStatusV2, getViajeUnidad } = useUnidades();
  const { user, negocioSeleccionado } = useContext(AuthContext);
  const { getUnitsBusqueda, putReasignarUnidad } = useUnidades();
  const [unidades, setUnidades] = useState([]);
  const [loading, setLoading] = useState(false);
  const [negocio, setNgocio] = useState();

  useEffect(() => {
    if(!socket) return;
      socket.on("unidades_en_ruta_" , async (data) => {
        if (data.idNegocio === user.negocio_id || data.idNegocio === parseInt(negocioSeleccionado)) 
        await UnidadesEnRuta();
      });
      return () => {
        socket.off('unidades_en_ruta_');
    }
  }, [socket]);

  const UnidadesEnRuta = async () => {
    setLoading(true);
    let resp = await getUnitsBusqueda(2);
    if (resp.ok) {
      let array = [];
      resp.unidades.map(({ unidad_id, unidad_numero, cedi, status, viajes, negocio_id}) => {
        setNgocio(negocio_id);
        if(viajes[0] && viajes[0].status_id === 6 )
        array.push({
          "unidad_id": unidad_id, 
          "unidad_numero": unidad_numero, 
          "cedi": cedi, 
          "status": status
        });

      });

      setUnidades(array);

    } else {
      setUnidades([]);
    }
    setLoading(false);
    
  };

  const liberarUnidad = async (unidad_id, status_id, flujo_id) => {
    setLoading(true);
    let viaje = await getViajeUnidad(unidad_id);
    if (viaje.ok) {
      let resp = await postBitacora({
        id_viaje: viaje.viaje_id,
        notas: `${status_id === 8 ? "La unidad fue liberada": "El viaje fue cancelado"}`,
        id_status: status_id,
      });
      
      
      resp = await putViajeStatusV2(viaje.viaje_id, status_id);
      if (!resp.ok) {
        Swal.fire({
          title: `No se pudo liberar la unidad`,
          text: resp.msg,
          icon: "error",
        });
        setLoading(false);
      } else {
        if (flujo_id === 2 && status_id === 8) await putReasignarUnidad(unidad_id);
        Swal.fire({
          title: "Unidad liberada",
          text: "La unidad ha sido liberada",
          icon: "success",
        });

        if(user.roles_id === 2) {
          socket.emit("traer-unidades-en-ruta_", { idNegocio: parseInt(negocio)});
          console.log("emit monitorista "+ parseInt(negocio));
        } else {
          socket.emit("traer-unidades-en-ruta_", { idNegocio: user.negocio_id});
        }

        await UnidadesEnRuta();
        setLoading(false);
      }
    }
  };

  return (
    <>
      {loading && <Loader />}
      <main className="container">
        {/* <div className="d-flex align-items-center p-3 my-3 text-white bg-purple rounded shadow-sm"> */}
        {/* <img className="me-3" src={logoEKT} alt="" width="48" height="38" /> */}
        {/* <div className="lh-1"> */}
        {/* <h1 className="h6 mb-0 text-dark lh-1">EKT</h1> */}
        {/* <small className="text-dark text-center">Nombre del cedis</small>
        </div>
      </div> */}
        { 
          unidades.length > 0 ? unidades.map((unidad) => {
            const { unidad_id, unidad_numero, cedi, status } = unidad;
            // if(viajes[0] && viajes[0].status_id === 6 ) {
              return (
                <div
                  className="row my-3 p-3 bg-body rounded shadow-sm"
                  key={unidad_id}
                >
                  {/* <h6 className="border-bottom pb-2 mb-0">Recent updates</h6> */}
                  <div className="col-6 d-flex text-muted pt-3">
                    <img
                      className="bd-placeholder-img flex-shrink-0 me-2 rounded"
                      width="32"
                      height="32"
                      alt=""
                      src={ruta}
                      role="img"
                      aria-label="Placeholder: 32x32"
                      preserveAspectRatio="xMidYMid slice"
                      focusable="false"
                    />

                    <p className="pb-3 mb-0 small lh-sm border-bottom">
                      <strong className="d-block text-gray-dark">
                        Eco: {unidad_numero}
                      </strong>
                      {cedi.nombre_cedis} - {status.nombre}
                    </p>
                  </div>
                  <div className="col-3">
                    <small className="d-block text-end mt-3 select">
                      <label
                        onClick={() => {
                          Swal.fire({
                            title: `¿Deseas cancelar el viaje de la unidad ${unidad_numero}?`,
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "¡Si!",
                            cancelButtonText: "No",
                          }).then((result) => {
                            if (result.isConfirmed)
                              return liberarUnidad(unidad_id, 9, cedi.flujo_id);
                          });
                        }}
                        className="cursor"
                        style={{
                          padding: "10px",
                          background: "#fdabab",
                          color: "#8a0b1b",
                        }} 
                      >
                        Cancelar Viaje y liberar unidad
                      </label>
                    </small>
                  </div>
                  <div className="col-3">
                  <small className="d-block text-end mt-3 select">
                    <label
                      onClick={() => {
                        Swal.fire({
                          title: `¿Deseas finalizar viaje y liberar la unidad ${unidad_numero}?`,
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "¡Si!",
                          cancelButtonText: "No",
                        }).then((result) => {
                          if (result.isConfirmed)
                            return liberarUnidad(unidad_id, 8, cedi.flujo_id);
                        });
                      }}
                      className="cursor"
                      style={{
                        padding: "10px",
                        background: "rgb(195, 247, 185)",
                        color: "#1f5905"
                      }}        
                    >
                      Finalizar viaje y liberar unidad
                    </label>
                  </small>
                  </div>
                </div>
              );
            // } 
            // else {
            //   return (
            //     <>
            //     <div className="my-3 p-3 bg-body rounded shadow-sm">
            //       {/* <h6 className="border-bottom pb-2 mb-0">Recent updates</h6> */}
            //       <div className="d-flex text-muted pt-3">
            //         <img
            //           className="bd-placeholder-img flex-shrink-0 me-2 rounded"
            //           width="32"
            //           height="32"
            //           alt=""
            //           src={check}
            //           role="img"
            //           aria-label="Placeholder: 32x32"
            //           preserveAspectRatio="xMidYMid slice"
            //           focusable="false"
            //         />

            //         <p className="pb-3 mb-0 small lh-sm border-bottom">
            //           <strong className="d-block text-gray-dark">
            //             Sin unidades que liberar
            //           </strong>
            //         </p>
            //       </div>
            //     </div>
            //   </>
            //   )
            // }
          })
         : (
          <div className="my-3 p-3 bg-body rounded shadow-sm">
            {/* <h6 className="border-bottom pb-2 mb-0">Recent updates</h6> */}
            <div className="d-flex text-muted pt-3">
              <img
                className="bd-placeholder-img flex-shrink-0 me-2 rounded"
                width="32"
                height="32"
                alt=""
                src={check}
                role="img"
                aria-label="Placeholder: 32x32"
                preserveAspectRatio="xMidYMid slice"
                focusable="false"
              />

              <p className="pb-3 mb-0 small lh-sm border-bottom">
                <strong className="d-block text-gray-dark">
                  Sin unidades que liberar
                </strong>
              </p>
            </div>

            {/* <small className="d-block text-end mt-3">
          <a className="text-dark">Detalles</a>
        </small> */}
          </div>
        )
        }
      </main>
    </>
  );
};
